export default "__VITE_ASSET__DdzXRMT7__"